<template>
	<div class="hit-container">

		<div class="hit-row">

			<div class="hit-col-md-12">
				<div class="hit-panel hit-panel-primary">

					<div class="hit-panel-heading">

						{{ entry.title }}

					</div>

					<div class="hit-panel-body" v-html="entry.content" />

					<div class="hit-panel-footer">

						<span class="hit-pull-right">
							<router-link class="hit-html-a" :to="{ name: 'blog', params: {lang: $store.getters.lang } }" >{{ $t("message.back") }}</router-link>
						</span>
						<div class="hit-clearfix" />
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>

export default{

  name: 'blogpost',

  data: function () {
    return {
      blog: [],
      entry: []
    }
  },

  mounted: function () {
    this.blog = [
      {title: 'Testeintrag 1', content: 'Hier kommt dann der Text'},
      {title: 'Testeintrag 2', content: 'Auch ein schöner Text'}
    ]

    this.entry = this.blog[this.$route.params.id]
  }
}
</script>

<style scoped>

</style>
